import { createSSRApp } from 'vue'
import App from './App.vue'
import createRouter from 'webmd-cms-router/src/router';
import { createPinia } from 'pinia';
import createStore from 'webmd-cms-store/src/store';
import pageDataMixin from 'webmd-page-common/src/util/pagedata';
import metric from 'webmd-vuejs-metrics';
import dfp from 'webmd-vue-ad/src/lib/dfp';
import locale from 'webmd-elements/lib/locale';
import lang from 'webmd-elements/lib/locale/lang/en';
import StickyPlugin from 'webmd-sticky/src/plugins/sticky/index.es6';
import 'webmd-elements/packages/theme-chalk/lib/typography.css';
const isSSR = typeof window === 'undefined';

import { appid } from '../kubeconfig.json';
export const $capId = appid.split('-')[0];

export default function () {
  // Create a new Pinia instance
  const pinia = createPinia();
  const app = createSSRApp(App);
  app.use(pinia);
  const piniaStore = createStore(pinia);

  const router = createRouter();

  app.use(router);
  app.use(StickyPlugin);
    app.mixin(pageDataMixin);
    app.use(metric,{ page: true });
    app.use(dfp);
    locale.use(lang);
    
  app.config.globalProperties.$capId = $capId;

  return {
    app,
    router,
    piniaStore,
  };
}